// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_21qlF","value":"_2AEks","filter":"_1nCUG","ico":"r9gkK"};